export default {"src":"https://cdn.tanzhi.cn/_next/static/media/job.3b54884e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};